'use client'

import { ReactNode } from 'react'
import { LibClientProviders } from '@/kmsApp/components/providers/lib-client-providers'

const ProvidersClient = ({ children }: { children: ReactNode }) => {
  return <LibClientProviders>{children}</LibClientProviders>
}

export default ProvidersClient
